
import { ActionCreator } from 'app/redux/ActionCreator'
import { IReducerAction } from 'app/redux/FunctionalReducer'
import { WorkbookServiceResponse } from 'app/services/models/Workbook'
import { OperationStatus } from 'app/services/OperationStatus'
import { genericFailure, WebServiceResponse } from 'app/services/WebServiceBase'
import { INosyParker, nullNosyParker } from 'app/utils/nosyParker'
import * as Redux from 'redux'

interface IOpState {
  op: OperationStatus
  results: any
}

interface IOpReducerAction<S extends IOpState> extends IReducerAction {
  type: string
  opState: S
}

interface IOpActionStates {
  OP_STARTING: string
  OP_COMPLETED: string
  OP_FAILED: string
}

function debug(what) {
  // tslint:disable-next-line:no-console
  //console.log(what)
}

class PensionActionCreator<S extends IOpState, IAction extends IReducerAction> extends ActionCreator<S, IAction> implements INosyParker {

  constructor(protected actionState: IOpActionStates) {
    super()
  }

  operationIsStarting() {
    const action = {
      type: this.actionState.OP_STARTING,
      opState: { op: new OperationStatus(), results: undefined as any }
    }
    debug('starting: ' + JSON.stringify(action, undefined, 4))
    this.dispatch(action as any)
  }

  operationHasCompleted(response: WorkbookServiceResponse) {
    const action = {
      type: this.actionState.OP_COMPLETED,
      opState: { op: OperationStatus.fromResponse(response), results: response.Results }
    }
    debug('completed: ' + JSON.stringify(action, undefined, 4))
    this.dispatch(action as any)
  }

  operationHasFailed(reason: any) {
    const action = {
      type: this.actionState.OP_FAILED,
      opState: { op: genericFailure(reason), results: undefined }
    }
    debug('failed: ' + JSON.stringify(action, undefined, 4))
    this.dispatch(action as any)
  }
}

export {
  IOpState,
  IOpReducerAction,
  IOpActionStates,

  PensionActionCreator
}



// WEBPACK FOOTER //
// ./src/app/redux/Pensions/actions/index.ts